import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.copyright.bannerTitle')} pagename={t('pages.legal.copyright.bannerPagename')} description={t('pages.legal.copyright.bannerDescription')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.copyright.title')}</h3>
                                    <p>{t('pages.legal.copyright.intro')}</p>

                                    <h4>{t('pages.legal.copyright.collection.heading')}</h4>
                                    <p>{t('pages.legal.copyright.collection.body1')}</p>
                                    <p>{t('pages.legal.copyright.collection.body2')}</p>
                                    <p>{t('pages.legal.copyright.collection.body3')}</p>

                                    <h4>{t('pages.legal.copyright.userRights.heading')}</h4>
                                    <p>{t('pages.legal.copyright.userRights.body')}</p>

                                    <h4>{t('pages.legal.copyright.disclosure.heading')}</h4>
                                    <p>{t('pages.legal.copyright.disclosure.body')}</p>

                                    <h4>{t('pages.legal.copyright.security.heading')}</h4>
                                    <p>{t('pages.legal.copyright.security.body')}</p>

                                    <h4>{t('pages.legal.copyright.compliance.heading')}</h4>
                                    <p>{t('pages.legal.copyright.compliance.body')}</p>

                                    <h4>{t('pages.legal.copyright.contact.heading')}</h4>
                                    <p>{t('pages.legal.copyright.contact.body')}</p>

                                    <p><strong>{t('pages.legal.copyright.establishedLabel')}</strong> {t('pages.legal.copyright.establishedValue')}</p>
                                    <p><strong>{t('pages.legal.copyright.lastRevisionLabel')}</strong> {t('pages.legal.copyright.lastRevisionValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
